import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NotificationsProviderComponent } from './shared/components/notifications-provider/notifications-provider.component';
import { PageMetaTagsAdapter } from '../domain/adapters/page-meta-tags.adapter';
import { Subscription } from 'rxjs';

const defaultMetaTags = [
  {
    name: 'description',
    content:
      'na2kolela.bg е твоят онлайн пазар за велосипеди, тротинетки и части. Разгледай обяви от цяла България. Продай лесно своето старо колело или намери перфектната тротинетка за теб.',
  },
  {
    name: 'og:title',
    content:
      'Велосипеди и Тротинетки Втора Ръка - Обяви и Части | na2kolela.bg',
  },
  {
    name: 'og:description',
    content:
      'Търсиш велосипед или тротинетка на добра цена? В na2kolela.bg ще откриеш стотици обяви за нови и втора ръка колела, тротинетки и части.',
  },
  {
    name: 'og:url',
    content: 'https://na2kolela.bg/',
  },
  {
    name: 'og:image',
    content: '/assets/2kolela.png',
  },
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [RouterOutlet, NotificationsProviderComponent],
})
export class AppComponent implements OnInit {
  title = 'client';
  subscription: Subscription | undefined;

  constructor(
    private router: Router,
    private pageMetaTagsService: PageMetaTagsAdapter
  ) {}

  setDefaultSeoTags() {
    this.pageMetaTagsService.updateTitle(
      'Обяви за Велосипеди, Тротинетки и Части - Нови и Втора Употреба | na2kolela.bg'
    );
    defaultMetaTags.forEach((tag) => {
      this.pageMetaTagsService.updateTag(tag);
    });
  }

  ngOnInit(): void {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setDefaultSeoTags();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
